<template>
  <modal name="skill-diagnosis-popup" :adaptive="true" :scrollable="true" height="auto" :clickToClose="true"
    :escToClose="true" @closed="handleClosed" class="skill-diagnosis-popup-modal">
    <div class="v--modal-close-top">
      <el-button @click="closePopup" icon="el-icon-circle-close" style="font-size: 2rem; padding: 0;"
        type="text"></el-button>
    </div>

    <div class="setting">
      <div class="prime-popup">
        <!-- ready 状態 -->
        <template v-if="state === 'ready'">
          <h2 v-if="isYagiPrime" class="p-h2">ヤギプライム限定</h2>
          <h2 v-else class="p-h2 p-h2--free">無料で体験</h2>
          <div class="diagnosisimg-wrapper">
            <img src="/static/mypage/img_diagnosis.png" alt="隠れスキル" class="diagnosisimg">
          </div>

          <p class="prime-title">あなたの履歴書、<br>実は「◯◯向き」診断！？</p>
          <p style="margin-bottom: 16px;">履歴書の職歴データから、あなたの「隠れスキル」と向いている職種を診断します。</p>
          <template v-if="canDiagnose">
            <button type="button" class="yagilog-popup-linkbtn" @click="runDiagnosis">
              隠れスキル診断を受ける
            </button>
          </template>
          <template v-else-if="!hasResumeData">
            <p class="sd-notice">履歴書を作成すると、あなたの強みを診断できます！</p>
            <a href="/format/rirekisho_job_change" class="yagilog-popup-linkbtn">
              まずは履歴書を作る
            </a>
          </template>
          <template v-else-if="needsJobHistory">
            <p class="sd-notice">{{ insufficientMessage }}</p>
            <a href="/format/rirekisho_job_change/edit/job-history" class="yagilog-popup-linkbtn">
              職歴を入力する
            </a>
          </template>
          <template v-else>
            <p class="sd-notice">{{ insufficientMessage }}</p>
            <button type="button" class="yagilog-popup-linkbtn" disabled>
              隠れスキル診断を受ける
            </button>
          </template>
        </template>

        <!-- loading 状態 -->
        <template v-if="state === 'loading'">
          <h2 class="p-h2">診断中...</h2>
          <div style="padding: 30px 0; text-align: center;">
            <div class="sd-spinner-inline"></div>
            <p style="margin-top: 16px; color: #666;">ヤギがあなたの隠れスキルを見ています</p>
          </div>
        </template>

        <!-- result 状態（会員：フル表示） -->
        <template v-if="state === 'result' && isYagiPrime">
          <h2 class="p-h2">診断結果</h2>
          <div class="sd-popup-result">
            <div class="sd-popup-row">
              <span class="sd-popup-label">市場タイプ</span>
              <span class="sd-popup-val sd-popup-accent">{{ zoneDisplayName }}</span>
            </div>
            <div class="sd-popup-row">
              <span class="sd-popup-label">強みタイプ</span>
              <span class="sd-popup-val sd-popup-accent">{{ result.strength_type }}</span>
            </div>
            <div class="sd-popup-row">
              <span class="sd-popup-label">向いている職種</span>
              <span class="sd-popup-val">{{ result.job_category_1 }} / {{ result.job_category_2 }} / {{ result.job_category_3 }}</span>
            </div>
            <div class="sd-popup-comment">{{ result.diagnosis_comment }}</div>
          </div>
          <button type="button" class="yagilog-popup-linkbtn-sub" @click="resetToReady">
            もう一度診断する
          </button>
        </template>

        <!-- result 状態（非会員：ぼかし表示 + CTA） -->
        <template v-if="state === 'result' && !isYagiPrime">
          <h2 class="p-h2 p-h2--free">診断結果</h2>
          <div class="sd-popup-result">
            <div class="sd-popup-row">
              <span class="sd-popup-label">市場タイプ</span>
              <span class="sd-popup-val sd-popup-accent">{{ zoneDisplayName }}</span>
            </div>
            <div class="sd-popup-row">
              <span class="sd-popup-label">強みタイプ</span>
              <span class="sd-popup-val sd-popup-accent">{{ result.strength_type }}</span>
            </div>
            <div class="sd-popup-row sd-popup-row--locked">
              <span class="sd-popup-label">向いている職種</span>
              <span class="sd-popup-val sd-popup-blur">{{ result.job_category_1 }} / {{ result.job_category_2 }} / {{ result.job_category_3 }}</span>
            </div>
          </div>
          <div class="sd-upsell-card">
            <p class="sd-upsell-desc">ヤギプライムに加入すると、あなたに向いている職種やAIによる詳しい診断コメントが確認できます。</p>
            <p class="sd-upsell-sub">＼ヤギプライムに加入して／</p>
            <button type="button" class="yagilog-popup-linkbtn" @click="openPaymentDialog">
              全結果を見る
            </button>
          </div>
          <button type="button" class="yagilog-popup-linkbtn-sub" @click="resetToReady">
            もう一度診断する
          </button>
        </template>

        <!-- error 状態 -->
        <template v-if="state === 'error'">
          <h2 class="p-h2">診断に失敗しました</h2>
          <p style="margin-bottom: 16px;">{{ errorMessage }}</p>
          <button type="button" class="yagilog-popup-linkbtn" @click="runDiagnosis">
            再度診断する
          </button>
        </template>

        <div class="check" v-if="showSkipOption">
          <label class="checkbox-container">
            <input type="checkbox" :checked="hidePopupFor10Days"
              @click="hidePopupFor10Days = !hidePopupFor10Days" />
            <span class="checkbox-text">スキップする（10日間表示しない）</span>
          </label>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'SkillDiagnosisPopup',
  data () {
    return {
      state: 'ready',
      canDiagnose: true,
      insufficientMessage: '',
      result: null,
      errorMessage: '',
      resumeData: null,
      hasResumeData: false,
      needsJobHistory: false,
      showSkipOption: false,
      hidePopupFor10Days: false
    }
  },
  computed: {
    isYagiPrime () {
      return !!this.$globalVar.isYagiPrime && !this.$globalVar.isYagiPrimeCancel
    },
    zoneDisplayName () {
      if (!this.result) return ''
      const map = {
        A: 'キャリアアップ型',
        B: 'ハイブリッド型',
        C: '即戦力型'
      }
      return map[this.result.zone] || this.result.zone
    }
  },
  methods: {
    showPopup (options) {
      this.state = 'ready'
      this.result = null
      this.errorMessage = ''
      this.hidePopupFor10Days = false
      this.showSkipOption = !!(options && options.showSkip)
      this.needsJobHistory = false
      this.checkData()
      this.$modal.show('skill-diagnosis-popup')
    },

    closePopup () {
      if (this.hidePopupFor10Days && this.showSkipOption) {
        const currentDate = new Date()
        const tenDaysLater = new Date(currentDate.getTime() + (10 * 24 * 60 * 60 * 1000))
        const hideUntil = tenDaysLater.getTime()
        this.$cookies.set('_YAGISH_AGENTFORM_POPUP_HIDE_UNTIL', hideUntil, 60 * 60 * 24 * 10)
        this.hidePopupFor10Days = false
      }
      this.$modal.hide('skill-diagnosis-popup')
    },

    handleClosed () {
      // state はリセットしない（再度開いたときに showPopup で初期化）
    },

    getUuid () {
      try {
        return this.$firebase.user && this.$firebase.user.uid
      } catch (e) {
        return null
      }
    },

    checkData () {
      const uuid = this.getUuid()
      if (!uuid) {
        this.canDiagnose = false
        this.insufficientMessage = 'ログインが必要です。'
        return
      }

      const app = this
      let basicData = null
      let formatData = null

      this.$iterateStorage(function (value, key) {
        if (key === 'basicData') {
          basicData = value
        }
        if (typeof key === 'string' && key.indexOf('format_') === 0 && value && !formatData) {
          formatData = value
        }
      }, function () {
        app.resumeData = Object.assign({}, basicData || {}, formatData || {})
        const fd = app.resumeData

        const hasDate = fd.birthYear && fd.birthMonth && fd.birthDay
        const hasJobs = fd.jobHistories && fd.jobHistories.length > 0

        if (!basicData && !formatData) {
          app.canDiagnose = false
          app.hasResumeData = false
          app.insufficientMessage = '履歴書データが見つかりません。先に履歴書を作成してください。'
        } else if (!hasDate && !hasJobs) {
          app.canDiagnose = false
          app.hasResumeData = true
          app.needsJobHistory = true
          app.insufficientMessage = '履歴書の生年月日と職歴を入力すると診断できます。'
        } else if (!hasDate) {
          app.canDiagnose = false
          app.hasResumeData = true
          app.insufficientMessage = '履歴書の生年月日を入力すると診断できます。'
        } else if (!hasJobs) {
          app.canDiagnose = false
          app.hasResumeData = true
          app.needsJobHistory = true
          app.insufficientMessage = '履歴書の職歴を入力すると診断できます。'
        } else {
          app.canDiagnose = true
          app.hasResumeData = true
          app.insufficientMessage = ''
        }
      })
    },

    async runDiagnosis () {
      const uuid = this.getUuid()
      const fd = this.resumeData
      if (!uuid || !fd) {
        this.state = 'error'
        this.errorMessage = 'データが不足しています。ポップアップを開き直してください。'
        return
      }

      this.state = 'loading'

      try {
        const jobDescriptions = (fd.jobHistories || [])
          .map(j => j.description || '')
          .filter(d => d)

        const eduHistories = fd.educationalHistories || []
        const latestEdu = eduHistories.length > 0 ? (eduHistories[eduHistories.length - 1].description || '') : ''

        const payload = {
          uuid,
          birthyear: fd.birthYear,
          birthmonth: fd.birthMonth,
          birthday: fd.birthDay,
          lastest_educational: fd.lastestEducational || '',
          educational_text: latestEdu,
          job_histories: jobDescriptions
        }

        // 会員はフル診断、非会員はlite版
        const endpoint = this.isYagiPrime
          ? this.$varuna.endPoints.runSkillDiagnosis
          : this.$varuna.endPoints.runSkillDiagnosisLite

        const response = await this.$axios.post(
          endpoint,
          JSON.stringify(payload),
          { timeout: 60000, headers: { 'Content-Type': 'application/json' } }
        )

        if (response.data && response.data.success) {
          this.result = response.data
          this.state = 'result'
        } else {
          this.errorMessage = (response.data && response.data.message) || '診断に失敗しました。時間をおいて再度お試しください。'
          this.state = 'error'
        }
      } catch (error) {
        const msg = (error.response && error.response.data && error.response.data.message) || '診断に失敗しました。時間をおいて再度お試しください。'
        this.errorMessage = msg
        this.state = 'error'
      }
    },

    resetToReady () {
      this.state = 'ready'
      this.result = null
      this.errorMessage = ''
    },

    openPaymentDialog () {
      this.closePopup()

      const onResult = (result) => {
        if (result === 'success' || (result && result.status === 'success')) {
          this.$eventHub.$emit('hide-yagiprime-payment-dialog')
          // 課金完了 → 会員フラグを即時反映してフル版APIを呼ぶ
          this.$globalVar.isYagiPrime = true
          this.$globalVar.isYagiPrimeCancel = false
          this.$nextTick(() => {
            this.showPopup()
            this.runDiagnosis()
          })
        }
        this.$eventHub.$off('payment_yagiprime_result', onResult)
      }
      this.$eventHub.$on('payment_yagiprime_result', onResult)

      this.$eventHub.$emit('show-yagiprime-payment-dialog')
    }
  },

  created () {
    this.$eventHub.$on('show-skill-diagnosis-popup', this.showPopup)
  },

  beforeDestroy () {
    this.$eventHub.$off('show-skill-diagnosis-popup', this.showPopup)
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.setting {
  .prime-popup {
    font-size: 14px;
    margin-bottom: 20px;
    min-width: 450px;

    @include max-width(sm) {
      min-width: auto;
    }

    .p-h2 {
      position: relative;
      display: inline-block;
      padding: 2px 10px;
      color: #ffffff;
      font-weight: bold;
      font-size: 12px;
      background: #FF8C00;
      border-radius: 30px;
      top: -40px;

      &--free {
        background: #4CAF50;
      }
    }

    .sd-notice {
      color: #999;
      font-size: 12px;
      margin-top: 8px;
    }

    .yagilog-popup-linkbtn {
      position: relative;
      display: inline-block;
      background: #E3165C;
      color: #ffffff;
      font-weight: bold;
      font-size: 18px;
      width: 100%;
      padding: 10px;
      line-height: 1.4;
      border-radius: 10px;
      border: 1px solid #d1345e;
      text-align: center;
      cursor: pointer;

      &::after {
        position: absolute;
        content: "";
        width: 14px;
        height: 14px;
        border: 0;
        border-bottom: 3px solid #fff;
        border-right: 3px solid #fff;
        -webkit-transform: rotate(-45deg);
        transform: rotate(-45deg);
        top: 0;
        right: 15px;
        bottom: 0;
        margin: auto;
      }

      span {
        font-size: 14px;
      }

      &:hover {
        opacity: 1;
        text-decoration: none;
        background: #ffffff;
        color: #d1345e;

        &::after {
          border-bottom: 3px solid #d1345e;
          border-right: 3px solid #d1345e;
        }
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
      }
    }

    .yagilog-popup-linkbtn-sub {
      display: block;
      margin: 10px auto 0;
      padding: 10px 20px;
      font-size: 13px;
      color: #E3165C;
      background: #fff;
      border: 1px solid #E3165C;
      border-radius: 25px;
      cursor: pointer;

      &:hover {
        background: #fef0f3;
      }
    }

    .sd-spinner-inline {
      width: 36px;
      height: 36px;
      margin: 0 auto;
      border: 4px solid #f0f0f0;
      border-top: 4px solid #E3165C;
      border-radius: 50%;
      animation: sd-spin-inline 1s linear infinite;
    }

    @keyframes sd-spin-inline {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }

    .sd-popup-result {
      text-align: left;
      margin-bottom: 16px;

      .sd-popup-row {
        display: flex;
        align-items: baseline;
        gap: 8px;
        margin-bottom: 8px;
        padding: 8px 10px;
        background: #fafafa;
        border-radius: 6px;
        border-left: 3px solid #E3165C;

        &--locked {
          position: relative;
        }
      }

      .sd-popup-label {
        font-size: 11px;
        color: #999;
        font-weight: bold;
        white-space: nowrap;
        min-width: 70px;
      }

      .sd-popup-val {
        font-size: 14px;
        font-weight: bold;
        color: #333;
      }

      .sd-popup-accent {
        color: #E3165C;
        font-size: 16px;
      }

      .sd-popup-blur {
        filter: blur(6px);
        user-select: none;
        pointer-events: none;
      }

      .sd-lock-icon {
        font-size: 14px;
        margin-left: auto;
      }

      .sd-popup-comment {
        font-size: 13px;
        line-height: 1.7;
        color: #444;
        padding: 10px;
        background: #fafafa;
        border-radius: 6px;
        white-space: pre-wrap;
      }
    }

    .sd-upsell-card {
      background: linear-gradient(135deg, #fff8e1, #fff3e0);
      border: 1px solid #FFB74D;
      border-radius: 8px;
      padding: 16px;
      margin-bottom: 12px;

      .sd-upsell-desc {
        font-size: 13px;
        color: #555;
        line-height: 1.6;
        margin-bottom: 12px;
      }

      .sd-upsell-sub {
        font-size: 12px;
        color: #E65100;
        font-weight: bold;
        text-align: center;
        margin-bottom: 4px;
      }
    }

    .check {
      margin: 15px 0;
      color: #404040;
      opacity: 0.5;

      .checkbox-container {
        display: flex;
        align-items: center;
        cursor: pointer;
        justify-content: center;

        input[type="checkbox"] {
          display: none;
        }

        .checkbox-text {
          user-select: none;
        }
      }
    }
  }
}

.prime-title {
  font-size: 18px;
  font-weight: bold;
  color: #004D40;
  margin-bottom: 10px;
  text-align: center;
}

.diagnosisimg-wrapper {
  text-align: center;

  .diagnosisimg {
    width: 300px;
    margin-top: -25px;
    margin-bottom: 10px;
  }
}
</style>

<style lang="scss">
@import '@/assets/scss/variables.scss';

.skill-diagnosis-popup-modal {
  .v--modal {
    margin: 0 !important;
    width: 70% !important;
    max-width: 600px !important;
    min-width: 450px !important;
    border-radius: 8px;
    padding: 20px;
    left: 50% !important;
    top: 50% !important;
    transform: translate(-50%, -50%) !important;
    position: fixed !important;

    @media (max-width: 480px) {
      width: 90% !important;
      min-width: 300px !important;
      max-width: calc(100vw - 20px) !important;
    }
  }
}
</style>
